import * as React from 'react';
import * as style from './ReviewItem.css';

export interface IReviewItemProps {
  author: React.ReactElement<any>;
  comment: React.ReactElement<any>;
  answers: React.ReactElement<any> | false;
  reaction: React.ReactElement<any> | false;
}

export const ReviewItem: React.FC<IReviewItemProps> = ({ author, comment, answers, reaction }) => {
  return (
    <div data-testid="ReviewItem" className={style['wrapper']}>
      <div className={style['header']}>{author}</div>
      <div className={style['content']}>{comment}</div>
      <div className={style['footer']}>
        {reaction}
        {answers}
      </div>
    </div>
  );
};
